import { useEffect } from "react";
import { Switch, Route, useLocation } from "wouter";

import Home from "./routes/Home";
import Login from "./routes/Login";
import QuestLog from "./routes/QuestLog";
import ErrorPage from "./error-page";
import Signup from "./routes/Signup";
import Verify from "./routes/Verify";
import Settings from "./routes/Settings";

const signupRoutes = ["/login", "/signup", "/verify"];

const App = () => {
    const [location, setLocation] = useLocation();

    useEffect(() => {
        if (location === "/") return;

        const hasSomeFormOfAuth =
            sessionStorage.getItem("accessToken") ||
            localStorage.getItem("refreshToken");
        if (signupRoutes.includes(location) && hasSomeFormOfAuth) {
            setLocation("/questlog");
            return;
        }

        if (signupRoutes.includes(location)) return;

        if (!hasSomeFormOfAuth) {
            setLocation("/login");
            return;
        }
    }, [location, setLocation]);

    return (
        <div
            style={{
                width: "100vw",
                /* minWidth: "768px", */
                height: "100vh",
                display: "flex",
            }}
        >
            <Switch>
                <Route path="/" component={Home} />
                <Route path="/login" component={Login} />
                <Route path="/signup" component={Signup} />
                <Route path="/verify" component={Verify} />
                <Route path="/questlog/:sub*">
                    {(params) => <QuestLog sub={params.sub} />}
                </Route>
                <Route path="/settings" component={Settings} />
                <Route component={ErrorPage} />
            </Switch>
        </div>
    );
};

export default App;
